@if (loading()) {
  <mat-progress-bar class="py-2" mode="indeterminate"></mat-progress-bar>
}
<ng-template #errorTemplate let-error let-refresh="refresh">
  <rxap-data-source-error [error]="error" [refresh]="refresh"></rxap-data-source-error>
</ng-template>
<div *rxapDataSource="let panel from panelDataSource; errorTemplate: errorTemplate" class="flex flex-col gap-4">
  <eurogard-boxed-slide-toggle-control
    #alarmingToggle
    (ngModelChange)="toggleAlarming($event, alarmingToggle)"
    [disabled]="loading()"
    [ngModel]="panel.alarmingEnabled">
    <ng-container label i18n>Alarming</ng-container>
  </eurogard-boxed-slide-toggle-control>

  <eurogard-boxed-slide-toggle-control
    #pushNotificationsToggle
    (ngModelChange)="togglePushNotification($event, pushNotificationsToggle)"
    [disabled]="!panel.alarmingEnabled || loading()"
    [ngModel]="panel.pushNotificationEnabled"
  >
    <div class="inline-block" label>
      <ng-container i18n>Push Notification</ng-container>
    </div>
    @if (firebaseTokensData()?.length) {
      <div class="flex flex-col mt-4 gap-4" content>
        @for (tokenObject of firebaseTokensData(); track $index) {
          <div class="flex flex-row flex-wrap items-center gap-4 w-fit">
            @if (tokenObject.customDevice?.includes('Android')) {
              <mat-icon svgIcon="custom-android"></mat-icon>
            } @else if (tokenObject.customDevice?.includes('iOS')) {
              <mat-icon svgIcon="custom-ios"></mat-icon>
            } @else if (tokenObject.customDevice?.includes('Chrome')) {
              <mat-icon svgIcon="custom-chrome"></mat-icon>
            } @else if (tokenObject.customDevice?.includes('Firefox')) {
              <mat-icon svgIcon="custom-firefox"></mat-icon>
            } @else if (tokenObject.customDevice?.includes('Other')) {
              <mat-icon svgIcon="custom-other-browser"></mat-icon>
            } @else {
              <mat-icon>question_mark</mat-icon>
            }
            <div class="flex flex-col min-w-0 flex-1">
              <div class="text-base truncate"><ng-container i18n>Device</ng-container>: {{ tokenObject.customDevice }}</div>
              <div class="text-base truncate"><ng-container i18n>FCM token</ng-container>: {{ tokenObject.fcmToken }}</div>
              <div class="text-sm truncate"><ng-container i18n>Last used</ng-container>: {{ tokenObject.lastUpdatedAt | dateWithTimeAgo : true }}</div>
            </div>

            @if (tokenObject.uuid && panel.alarmingEnabled && panel.pushNotificationEnabled) {
              <div class="flex flex-row items-center gap-2">
                <button
                  [disabled]="loading()"
                  (click)="sendPushTestNotification(tokenObject.uuid)"
                  color="primary"
                  class="!min-w-fit"
                  mat-raised-button
                  type="button"
                >
                  <ng-container i18n>Test Notification</ng-container>
                </button>
                <button
                  [disabled]="loading()"
                  rxapConfirm
                  (confirmed)="deleteFirebaseToken(tokenObject.uuid)"
                  color="warn"
                  mat-icon-button
                  type="button"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>

        }
      </div>
    }
  </eurogard-boxed-slide-toggle-control>

  <eurogard-boxed-slide-toggle-control
    #emailNotificationsToggle
    (ngModelChange)="toggleEmailNotification($event, emailNotificationsToggle)"
    [disabled]="!panel.alarmingEnabled || loading()"
    [ngModel]="panel.emailNotificationEnabled"
  >
    <ng-container label i18n>Email Notification</ng-container>
    <div class="inline-block ml-4" content>
      @if (panel.alarmingEnabled && panel.emailNotificationEnabled) {
        <button
          [disabled]="loading()"
          (click)="sendEmailTestNotification()"
          color="primary"
          class="grow-0"
          mat-raised-button
          type="button"
        >
          <ng-container i18n>Test Notification</ng-container>
        </button>
      }
    </div>
  </eurogard-boxed-slide-toggle-control>

  <eurogard-boxed-slide-toggle-control
    #telegramNotificationsToggle
    (ngModelChange)="toggleTelegramNotification($event, telegramNotificationsToggle)"
    [disabled]="!panel.alarmingEnabled || loading()"
    [ngModel]="useTelegramAlarming()"
  >
    <ng-container label i18n>Telegram Notification</ng-container>
    <div class="flex flex-col mt-4" content>
      <div *ngIf="hasCurrentTelegramCredentials" class="flex gap-4">
        <div class="flex gap-2"><span i18n>Current API Key:</span><span>{{ notificationAccordionData()?.telegramApiToken }}</span></div>
        <div class="flex gap-2"><span i18n>Current Chat ID:</span><span>{{ notificationAccordionData()?.telegramChatId }}</span></div>
      </div>
      <div class="flex items-center gap-4 mt-4">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label i18n>API Key</mat-label>
          <input
            type="text"
            [disabled]="loading() || !useTelegramAlarming()"
            [ngModel]="telegramAPIToken()"
            (ngModelChange)="telegramAPIToken.set($event)"
            placeholder="Enter API Key"
            i18n-placeholder
            matInput
            [required]="!hasCurrentTelegramCredentials"
          >
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label i18n>Chat ID</mat-label>
          <input
            type="text"
            [disabled]="loading() || !useTelegramAlarming()"
            [ngModel]="telegramChatId()"
            (ngModelChange)="telegramChatId.set($event)"
            placeholder="Enter Chat ID"
            i18n-placeholder
            matInput
            required
          >
        </mat-form-field>
        <button
          [disabled]="loading() || !useTelegramAlarming() || !telegramChatId() || (!hasCurrentTelegramCredentials && !telegramAPIToken())"
          (click)="saveTelegramCredentials()"
          color="primary"
          class="grow-0"
          mat-raised-button
          type="button"
        >
          {{ saveButtonLabelTelegram }}
        </button>
        @if (hasCurrentTelegramCredentials && useTelegramAlarming()) {
          <button
            [disabled]="loading()"
            (click)="sendTelegramTestNotification()"
            color="primary"
            class="grow-0"
            mat-raised-button
            type="button"
          >
            <ng-container i18n>Test Notification</ng-container>
          </button>
        }
      </div>
    </div>
  </eurogard-boxed-slide-toggle-control>

  <eurogard-boxed-slide-toggle-control
    #smsNotificationsToggle
    (ngModelChange)="toggleSMSNotification($event, smsNotificationsToggle)"
    [disabled]="!panel.alarmingEnabled || loading() || !smsServiceAvailable()"
    [ngModel]="useSMSAlarming()"
  >
    <ng-container label i18n>SMS Notification</ng-container>
    <div class="flex flex-col mt-4" content>
      @if (smsServiceAvailable()) {
        <div *ngIf="hasCurrentMobilePhone" class="flex gap-4">
          <div class="flex gap-2"><span i18n>Current phone number:</span><span>{{ notificationAccordionData()?.mobilePhone }}</span></div>
        </div>
        <div class="flex items-center gap-4 mt-4">
          <form #f="ngForm" [formGroup]="phoneForm">
            <ngx-intl-tel-input
              #phoneInput
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [searchCountryField]="searchCountryField"
              [selectFirstCountry]="false"
              [selectedCountryISO]="selectedCountryISO()"
              [separateDialCode]="true"
              [maxLength]="15"
              [phoneValidation]="true"
              [searchCountryPlaceholder]="searchCountryPlaceholder"
              formControlName="mobilePhone"
            ></ngx-intl-tel-input>
          </form>
          <button
            [disabled]="loading() || !useSMSAlarming() || !phoneForm.valid || phoneForm.get('mobilePhone')?.value?.e164Number === notificationAccordionData()?.mobilePhone"
            (click)="saveMobilePhone()"
            color="primary"
            class="grow-0"
            mat-raised-button
            type="button"
            i18n
          >Update phone number</button>
          @if (hasCurrentMobilePhone && useSMSAlarming()) {
            <button
              [disabled]="loading()"
              (click)="sendSMSTestNotification()"
              color="primary"
              class="grow-0"
              mat-raised-button
              type="button"
            >
              <ng-container i18n>Test Notification</ng-container>
            </button>
          }
        </div>
      } @else {
        <div class="flex flex-row gap-4 items-center">
          <mat-icon class="text-primary-500 scale-150 mx-2">warning</mat-icon>
          <div class="flex flex-col gap-2">
            <div i18n>No SMS service available</div>
            <div i18n>For more information, please contact your administrator.</div>
          </div>
        </div>
      }
    </div>
  </eurogard-boxed-slide-toggle-control>

  @if (notificationAccordionData()) {
    <mat-accordion>
      <mat-expansion-panel>

        <mat-expansion-panel-header>
          <mat-panel-title i18n>Alarming timeslots</mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <eurogard-alarm-group-form
            [showOnlyTimeslots]="true"
            [enforceCompactDesign]="enforceCompactDesign()"
            [submitMethod]="updateUserActiveTimeMethod"
            [initial]="initialTimeslotsData()"
          ></eurogard-alarm-group-form>
        </ng-template>

      </mat-expansion-panel>
    </mat-accordion>
  }
</div>
